import React, { useEffect, useState } from "react";
import { useObjectStore } from "../zustand/objects";
import { Select } from '@mantine/core';

import ModelPoses from "../ModelPoses.json";

import {getPoses} from "../api.js"

const PosesButton = ({ pose, object, id, uiTheme }) => {
  
  const { updatePose, currentObjectArtboard, arrangeUndoRedo } = useObjectStore();

  const posesObject = {}

  const handleSelectUIImage = (name, path) => {
    // send current state to undoActions
    name && arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "pose"
      })
      // send update to zustand
     name && convertArrayToObject(poses).then(() => updatePose({
      id:id,
      currentObjectArtboard:currentObjectArtboard,
      pose: {
        name:name,
        modelPath: path
      },
      undo: false
    }))
  } 
  const handleSelectObject = (name) => {
  // send current state to undoActions
    name && arrangeUndoRedo({
     updateType: "objectUpdate", 
     artboard: currentObjectArtboard, 
     objectID: id,
     undo:false,
     field: "pose"
     })
     // send update to zustand
     name && convertArrayToObject(poses).then(() => updatePose({
      id:id,
      currentObjectArtboard:currentObjectArtboard,
      pose: {
        name: name,
        modelPath: posesObject[name].transformed_file.path
      },
      undo: false
    }))
  } 

  

  const [poses, setPoses] = useState([])
  const borderColour = uiTheme?.borderColour || "#E5E7EB";
  const iconColour = uiTheme?.iconColour || "#6A7282";
  const textColour = uiTheme?.textColour || "#111827";
  const placeholderColour = uiTheme?.placeholderColour || "#6A7282";
  

async function convertArrayToObject(array) {
    for (const item of array) {
      posesObject[item.name] = item;
    }
  }
  

  useEffect(() => {
    getPoses(object).then((e) => setPoses(e))
  }, [object])

  return (
    <div>
    {/* <div style={{ paddingTop: 8, paddingBottom:8, height: "100%", display: 'flex', justifyContent: 'flex-start', zindex: 1600, overflow: 'visible' }}> */}
   {ModelPoses[object] ? <Select
      // radius={16}
      size={'sm'}
      label="Mode"
      defaultValue={pose.name}
      data={[...ModelPoses[object]]}
      onChange={(e) =>   handleSelectUIImage(e, null)}
      styles={{
        label: { color: textColour, fontWeight: 600 },
        input: {
          color: textColour,
          borderColor: borderColour,
          "&:focus": { borderColor: borderColour },
          "&:focus-within": { borderColor: borderColour },
        },
        section: { color: iconColour },
        placeholder: { color: placeholderColour },
      }}
      // style={{dropdown: {width: "100%"}, input: {width: 120}}}
    /> :
   poses.length > 0 && <Select
      // radius={16}
      size={'sm'}
      label="Mode"
      defaultValue={pose.name}
      data={poses.map((obj) => (obj.name))
      }
      onChange={(e) => handleSelectObject(e)}
      styles={{
        label: { color: textColour, fontWeight: 600 },
        input: {
          color: textColour,
          borderColor: borderColour,
          "&:focus": { borderColor: borderColour },
          "&:focus-within": { borderColor: borderColour },
        },
        section: { color: iconColour },
        placeholder: { color: placeholderColour },
      }}
      // style={{dropdown: {width: "100%"}, input: {width: 120}}}      
      // onChange={(e) => handleSelect(e,  posesObject.e.transformed_file.path)}
    />}

  </div>
 

  );
};

export default PosesButton;










